module.exports = __webpack_public_path__ + "static/media/Jalapenopescado.959ea21f.jpg";